const Log4js = require('../log4js.combined.js');
const BasicTimerLayout = require('../layouts/BasicTimerLayout.js').BasicTimerLayout;

/**
 * @description based on SimpleLayout by Stephan Strittmatter
 *   
 * @constructor
 * @extends Log4js.Appender
 */
var TimingConsoleAppender = function () {
  this.layout = new BasicTimerLayout();
};

TimingConsoleAppender.prototype = Log4js.extend(new Log4js.Appender(), {
  /** 
   * @see Log4js.Appender#doAppend
   */
  doAppend: async function (loggingEvent) {
    var format = this.layout.format.call(this.layout, loggingEvent);
    console.log(format);
  },
  /** 
   * @see Log4js.Appender#doClear
   */
  doClear: function () {
    this.doClear();
  },
  /**
   * @see Log4js.Appender#setLayout
   */
  setLayout: function (layout) {
    this.setLayout(layout);
  },
  /** 
   * toString
   */
  toString: function () {
    return "TimingConsoleAppender";
  }
});

module.exports = {
  TimingConsoleAppender
}